import { RootState } from "../../store";
import { createSelector } from "@reduxjs/toolkit";
import { IRentalState } from "../../interfaces/state";

const selectRental = (state: RootState): IRentalState => state.rental;

export const selectRentalData = createSelector([selectRental], (rental) => rental.rental);